import React from 'react';
import useCompany from 'core/hooks/useCompany';
import { formatFederalTaxNumber } from 'util/formatters';
import { Col, Row } from 'antd';

const ReportHeader = ({ title, children, renderRight }) => {
  const { company } = useCompany();

  const companyName = company?.name;
  const federalTaxNumber = formatFederalTaxNumber(company.federalTaxNumber);

  return (
    <Row className="no-margin no-padding gx-mb-3" justify="space-between">
      <Col>
        <div>
          <span className="gx-font-weight-semi-bold gx-fs-md">
            <span className="gx-mr-1">{companyName}</span>
            {federalTaxNumber && (
              <span className="gx-font-weight-semi-bold gx-fs-md">
                {`(${federalTaxNumber})`}
              </span>
            )}
          </span>
        </div>
        <div>
          <span className="gx-font-weight-semi-bold gx-fs-md">{title}</span>
        </div>
        {children}
      </Col>

      <Col>{renderRight}</Col>
    </Row>
  );
};

export default ReportHeader;
